// @flow
type ServerSideNotification = $ReadOnly<{alert: boolean, message: string}>

// Hands over the flash messages the server rendered for this page, once. The
// island remounts on every Turbo visit, and not every visit re-renders the
// script that sets them, so whatever is left behind would show again.
export default function consumeServerSideNotifications(): $ReadOnlyArray<ServerSideNotification> {
  /* eslint-disable no-underscore-dangle */
  const notifications = window.__serverSideNotifications || []
  window.__serverSideNotifications = []
  /* eslint-enable no-underscore-dangle */

  return notifications
}
